<template>
    <div>
        <!-- Invoice Template -->
        <div id="downloadInvoice">
            <div class="d-flex justify-content-between">
                <div style="width: 212px;height: 64px;margin-top: 25px;color: #FFFFFF;background: #266423;">
                    <div style="width: 156px;height: 39px;margin-left: 76px;margin-top: 20px;">Zhulia</div>
                </div>
                <div
                    style="width: 136px;height: 44px;margin-left: 429px;margin-top: 30px;font-weight: 600;font-size: 36px;line-height: 44px;text-align: right;letter-spacing: 0.05em;color: #6F6F84;">
                    Invoice</div>
            </div>
            <div class="d-flex justify-content-between">
                <div>
                    <br>
                    <h3
                        style="width: 354px;height: 35px;font-weight: 500;font-size: 24px;line-height: 29px;color: #000000;">
                        {{ data.sellerName ? data.sellerName : "" }} </h3>
                    <p
                        style="width: 242px;height: 17px;font-weight: normal;font-size: 14px;line-height: 17px;color: #6F6F84;">
                        {{ data.sellerAddress ? data.sellerAddress : "" }}</p>
                    <p
                        style="width: 242px;height: 17px;font-weight: normal;font-size: 14px;line-height: 17px;color: #6F6F84;">
                        {{ data.sellerCity ? data.sellerCity : "" }}</p>
                    <p
                        style="width: 242px;height: 17px;font-weight: normal;font-size: 14px;line-height: 17px;color: #6F6F84;">
                        {{ data.sellerCountry ? data.sellerCountry : "" }}</p>
                    <p
                        style="width: 242px;height: 17px;font-weight: 600;font-size: 14px;line-height: 17px;margin-top:30px;color: #222234;">
                        Date : {{ data.cowtribeDate ? data.cowtribeDate : '' }}</p>
                </div>
                <div>
                    <p
                        style="width: 58px;height: 17px;margin-left: 507px;font-size: 14px;line-height: 17px;text-align: right;color: #6F6F84;">
                        Billed to,</p>
                    <p
                        style="width: 100%;font-weight: 600;font-size: 14px;line-height: 17px;text-align: right;color: #222234;">
                        {{ data.retailerName ? data.retailerName : '' }}</p>
                    <div
                        style="width: 126px;height: 60px;margin-left: 439px;font-size: 12px;line-height: 25px;text-align: right;color: #6F6F84;">
                        {{ data.retailerAddress ? data.retailerAddress : '' }}
                        <br />
                        {{ data.retailerCity ? data.retailerCity : '' }}, {{ data.retailerCountry ? data.retailerCountry
                        : '' }}
                    </div>

                    <div
                        style="height: 60px;margin-left: 439px;margin-top: 20px;font-weight: 600;font-size: 12px;line-height: 25px;text-align: right;color: #222234;">
                        {{ data.phoneNumber ? data.phoneNumber : '' }}
                    </div>
                </div>
            </div>
            <div style="margin-top:20px">
                <hr style="border: 1px solid #C7C7C7;">
            </div>
            <div>
                <div class="d-flex justify-content-between mx-3">
                    <div>
                        <div style="font-size: 14px;line-height: 17px;color: #6F6F84;">Invoice number</div>
                        <div style="font-weight: 600;font-size: 14px;line-height: 17px;color: #222234;">{{
                            data.invoiceId ? `#${data.invoiceId}` : 'N/A' }}</div>
                    </div>
                    <div>
                        <div style="font-size: 14px;line-height: 17px;color: #6F6F84;">Due Date</div>
                        <div style="font-weight: 600;font-size: 14px;line-height: 17px;color: #222234;">{{ data.dueDate
                            ? data.dueDate : 'N/A' }}</div>
                    </div>
                </div>
            </div>
            <div>
                <hr style="border: 1px solid #C7C7C7;">
            </div>
            <div style="margin-top:30px">
                <table class="table table-striped table-hover table-bordered fixed_header">
                    <thead>
                        <tr>
                            <th scope="col">Product Name</th>
                            <th scope="col">Quantity</th>
                            <th scope="col">UnitPrice(Ksh)</th>
                            <th scope="col">LineTotal(Ksh)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="product in data.products" :key="product.id">
                            <td>{{ product.productName }}</td>
                            <td>{{ product.quantity }}</td>
                            <td>{{ product.unitPrice.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</td>
                            <td>{{ product.lineTotal.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style="margin-top:20px" class="d-flex justify-content-between">
                <p style="font-weight: 600;font-size: 16px;line-height: 16px;letter-spacing: 0.05em;color: #6F6F84;">
                    Total</p>
                <p style="font-weight: bold;font-size: 16px;line-height: 15px;color: #222234;">{{ data.total ? `Ksh
                    ${data.total.toLocaleString(undefined, {minimumFractionDigits: 2})}` : 'N/A'}}</p>
            </div>
            <div
                style="height: 12px;font-weight: 500;margin-top:20px;font-size: 14px;line-height: 12px;letter-spacing: 0.05em;color: #6F6F84;">
                <p style="font-weight: 500;font-size: 14px;line-height: 12px;letter-spacing: 0.05em;color: #6F6F84;">
                    Terms & Conditions</p>
                {{ data.terms ? data.terms : "N/A" }}
            </div>
            <div class="d-flex justify-content-between">
                <div style="margin-top: 60px;">
                    <div
                        style="height: 15px;font-weight: 500;font-size: 15px;line-height: 15px;letter-spacing: 0.05em;color: #6F6F84;">
                        Bank Account Details</div>
                    <div
                        style="height: 17px;font-weight: 600;font-size: 16px;padding-top:10px;line-height: 17px;color: #6F6F84;">
                        Company Name: Cowtribe Kenya Limited</div>
                    <div
                        style="height: 17px;font-weight: 600;font-size: 16px;padding-top:20px;line-height: 17px;color: #6F6F84;">
                        Account Number: 01100676421001</div>
                    <div
                        style="height: 17px;font-weight: 600;font-size: 16px;padding-top:30px;line-height: 17px;color: #6F6F84;">
                        Bank: Cooperative Bank</div>
                    <div
                        style="height: 17px;font-weight: 600;font-size: 16px;padding-top:30px;line-height: 17px;color: #6F6F84;">
                        Bank Branch: Kilimani</div>
                </div>

                <div style="margin-top: 60px;">
                    <div
                        style="height: 15px;font-weight: 500;font-size: 15px;line-height: 15px;letter-spacing: 0.05em;color: #6F6F84;">
                        MPESA Details</div>
                    <div
                        style="height: 17px;font-weight: 600;font-size: 16px;padding-top:10px;line-height: 17px;color: #6F6F84;">
                        Business Number: 400200</div>
                    <div
                        style="height: 17px;font-weight: 600;font-size: 16px;padding-top:20px;line-height: 17px;color: #6F6F84;">
                        Account No.: 852802</div>
                    <div
                        style="height: 17px;font-weight: 600;font-size: 16px;padding-top:30px;line-height: 17px;color: #6F6F84;">
                        Business Name: Cowtribe Kenya Ltd</div>
                </div>
            </div>

            <div style="position: fixed;bottom: 0;width: 100%;">
                <div>
                    <hr style="border: 1px solid #C7C7C7;">
                </div>

                <div class="d-flex justify-content-between">
                    <div style="width: 100px;height: 17px;font-size: 14px;line-height: 17px;color: #418A49;">
                        www.zhulia.me</div>
                    <div style="width: 110px;height: 17px;font-size: 14px;line-height: 17px;color: #6F6F84;">
                        sales@zhulia.me</div>
                    <div style="height: 17px;font-size: 14px;line-height: 17px;color: #6F6F84;">+233559691061</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DownloadInvoice',
    data() {
        return {
            invoiceModalVisible: false,
            data: {
                sellerName: "",
                sellerAddress: "",
                sellerCity: "",
                sellerCountry: "",
                retailerName: '',
                retailerAddress: '',
                retailerCity: '',
                retailerCountry: '',
                dueDate: '',
                cowtribeDate: '',
                terms: "",
                invoiceId: '',
                reference: '',
                phoneNumber: '',
                total: '',
                products: [],
            }
        }
    },
    methods: {
        handleInvoiceModalCancel() {
            this.invoiceModalVisible = false
        },
        downloadInvoice(invoiceData) {
            this.data = invoiceData
            setTimeout(() => this.$htmlToPaper('downloadInvoice'), 1000);
        }
    },
    watch: {
        data(newValue) {
            this.data = newValue
        }
    }
}
</script>

<style scoped>
.modalStyle>>>.ant-modal-header {
    border-bottom: none;
}

.modalStyle>>>.ant-modal-footer {
    border-top: none;
}

.modalStyle {
    display: flex;
    justify-content: center;
}

.invoiceContainer {
    height: 842px;
    position: relative;
    background: #FFFFFF;
}

#downloadInvoice {
    display: none;
}

.divider-2 {
    position: absolute;
    width: 535px;
    height: 0px;
    left: 30px;
    top: 300px;
}

.divider-3 {
    position: absolute;
    width: 535px;
    height: 0px;
    left: 30px;
    top: 806px;
}

.tableFixHead {
    overflow-y: auto;
    height: 200px;
}

.tableFixHead thead th {
    position: sticky;
    top: 0;
}

.tableFixHead table {
    border-collapse: collapse;
    width: 100%;
}

.tableFixHead th,
.tableFixHead td {
    padding: 8px 16px;
    border: 1px solid #ccc;
}

.tableFixHead th {
    background: #eee;
}

.subTotal {
    position: absolute;
    width: 88%;
    height: 15px;
    left: 31px;
    top: 599px;
}

.subTotal p:first-of-type {
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 15px;
    letter-spacing: 0.05em;
    color: #6F6F84;
}

.subTotal p:last-of-type {
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 15px;
    color: #222234;
}

.ant-divider-horizontal {
    border: 1px solid #C7C7C7;
}
</style>